import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const ScriveEditDocumentTypes = () =>
  import(
    /* webpackChunkName: "ScriveEditDocumentTypes" */
    '@/views/configuration/arenaSign/ArenaSignEditDocumentTypes.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: 'scrivedocumenttypes',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'Scrive Document Types'
};

export const DocumentTypeRoutes = [
  {
    ...Configuration.Scrive.DocumentType.Management,
    components: {
      default: ScriveEditDocumentTypes,
      treeView: ConfigurationTreeView
    },
    meta
  }
];
